import {getSupplierName} from '../Foundations/Utils/SupplierUtils';

export enum tableKeys {
    ADDITIONAL_DRIVER = "Additional Driver (25+)",
    UNDERAGE_SURCHARGE = "Under Age Surcharge (Between 21-24)",
    PHL = "Probationary Licence Holders",
    GPS = "GPS",
    RF_SEAT = "Rear Facing Seat",
    FF_SEAT = "Forward Facing Seat",
    BOOSTER_SEAT = "Booster Seat"
}

type ancillarySuppliersType = {
    [key: string]: {
        name: string;
        data: {
            [key in tableKeys]: {
                pricing?: string;
                details?: string;
            }
        }
    }
}

const suppliers: ancillarySuppliersType = {
    AV: {
        name: getSupplierName('AV'),
        data: {
            [tableKeys.ADDITIONAL_DRIVER]: {
                pricing: "$7.35 per driver per day"
            },
            [tableKeys.UNDERAGE_SURCHARGE]: {
            },
            [tableKeys.PHL]: {
                pricing: "",
                details: "Not accepted"
            },
            [tableKeys.GPS]: {
                pricing: "$23.74 per day",
                details: ""
            },
            [tableKeys.RF_SEAT]: {
                pricing: "$23.90 per day",
                details: "Max $358.11"
            },
            [tableKeys.FF_SEAT]: {
                pricing: "$21.35 per day",
                details: "Max $213"
            },
            [tableKeys.BOOSTER_SEAT]: {
                pricing: "$21.35 per day",
                details: "Max $213.50"
            }
        }
    },
    BG: {
        name: getSupplierName('BG'),
        data: {
            [tableKeys.ADDITIONAL_DRIVER]: {
                pricing: "$7.35 per driver per booking"
            },
            [tableKeys.UNDERAGE_SURCHARGE]: {
                pricing: "N/A"
            },
            [tableKeys.PHL]: {
                pricing: "",
                details: "Not accepted"
            },
            [tableKeys.GPS]: {
                pricing: "$17.08 per day",
                details: "Max $178"
            },
            [tableKeys.RF_SEAT]: {
                pricing: "$24.04 per day",
                details: "Max $213.50"
            },
            [tableKeys.FF_SEAT]: {
                pricing: "$21.35 per day",
                details: "Max $213.50"
            },
            [tableKeys.BOOSTER_SEAT]: {
                pricing: "$21.35 per day",
                details: "Max $88"
            }
        }
    },
    BC: {
        name: getSupplierName('BC'),
        data: {
            [tableKeys.ADDITIONAL_DRIVER]: {
                pricing: "$20 per driver per booking"
            },
            [tableKeys.UNDERAGE_SURCHARGE]: {
                pricing: "N/A"
            },
            [tableKeys.PHL]: {
                pricing: "",
                details: "Not accepted"
            },
            [tableKeys.GPS]: {
                pricing: "N/A",
                details: ""
            },
            [tableKeys.RF_SEAT]: {
                pricing: "$12.50 per day",
                details: "capped at $100 per rental(8 days)"
            },
            [tableKeys.FF_SEAT]: {
                pricing: "$12.50 per day",
                details: "capped at $100 per rental(8 days)"
            },
            [tableKeys.BOOSTER_SEAT]: {
                pricing: "$12.50 per day",
                details: "capped at $100 per rental(8 days)"
            }
        }
    },
    HD: {
        name: getSupplierName('HD'),
        data: {
            [tableKeys.ADDITIONAL_DRIVER]: {
                pricing: "$5.50 per driver per day",
                details: "Capped at $27.50 per driver"
            },
            [tableKeys.UNDERAGE_SURCHARGE]: {
                pricing: "$15.00 per day",
            },
            [tableKeys.PHL]: {
                pricing: "",
                details: "Not accepted"
            },
            [tableKeys.GPS]: {
                pricing: "$20.90 per day",
                details: ""
            },
            [tableKeys.RF_SEAT]: {
                pricing: "$24.20 per day",
            },
            [tableKeys.FF_SEAT]: {
                pricing: "$24.20 per day",
            },
            [tableKeys.BOOSTER_SEAT]: {
                pricing: "$24.20 per day",
            }
        }
    },
    ER: {
        name: getSupplierName('ER'),
        data: {
            [tableKeys.ADDITIONAL_DRIVER]: {
                pricing: "$12.00 per driver per day"
            },
            [tableKeys.UNDERAGE_SURCHARGE]: {
                pricing: "$9.90 per day",
            },
            [tableKeys.PHL]: {
                details: "Must have the probationary licence for a minimum period of 12 months"
            },
            [tableKeys.GPS]: {
                pricing: "$8.00 per day",
                details: "capped at $66.00"
            },
            [tableKeys.RF_SEAT]: {
                pricing: "$10.10 per day",
                details: "capped at $99.00"
            },
            [tableKeys.FF_SEAT]: {
                pricing: "$10.10 per day",
                details: "capped at $99.00"
            },
            [tableKeys.BOOSTER_SEAT]: {
                pricing: "$6.60 per day",
                details: "capped at $66.00"
            }
        }
    },
    EN: {
        name: getSupplierName('EN'),
        data: {
            [tableKeys.ADDITIONAL_DRIVER]: {
                pricing: "$10",
                details: "(excludes GST) per driver per day"
            },
            [tableKeys.UNDERAGE_SURCHARGE]: {
                pricing: "$23.50 per day",
                details: "(excludes GST)"
            },
            [tableKeys.PHL]: {
                details: "$28.00 per day (excludes GST) Prestige fleet not accepted"
            },
            [tableKeys.GPS]: {
                pricing: "$19.80 per day",
                details: "Capped at $118.80 for 6 days"
            },
            [tableKeys.RF_SEAT]: {
                pricing: "$77.00 per rental",
            },
            [tableKeys.FF_SEAT]: {
                pricing: "$77.00 per rental",
            },
            [tableKeys.BOOSTER_SEAT]: {
                pricing: "$44.00 per rental"
            }
        }
    },
    EC: {
        name: getSupplierName('EC'),
        data: {
            [tableKeys.ADDITIONAL_DRIVER]: {
                pricing: "$7.61 per driver per day",
                details: "Max $38.12"
            },
            [tableKeys.UNDERAGE_SURCHARGE]: {
                pricing: "$21.87 per day"
            },
            [tableKeys.PHL]: {},
            [tableKeys.GPS]: {
                pricing: "$15.40 per day",
                details: "Max $204.02"
            },
            [tableKeys.RF_SEAT]: {
                pricing: "$21.87 per day",
                details: "Max $116.58"
            },
            [tableKeys.FF_SEAT]: {
                pricing: "$21.87 per day",
                details: "Max $116.58"
            },
            [tableKeys.BOOSTER_SEAT]: {
                pricing: "$21.87 per day",
                details: "Max $116.58"
            }
        }
    },
    EF: {
        name: getSupplierName('EF'),
        data: {
            [tableKeys.ADDITIONAL_DRIVER]: {
                pricing: "From $22 to $33",
            },
            [tableKeys.UNDERAGE_SURCHARGE]: {
                pricing: "From $22 to $33",
            },
            [tableKeys.PHL]: {
                details: "Not accepted",
            },
            [tableKeys.GPS]: {
                pricing: "$10.00 per day",
                details: "Max $40.00"
            },
            [tableKeys.RF_SEAT]: {
                pricing: "$10.00",
                details: "Max $40.00"
            },
            [tableKeys.FF_SEAT]: {
                pricing: "$10.00",
                details: "Max $40.00"
            },
            [tableKeys.BOOSTER_SEAT]: {
                pricing: "$10.00",
                details: "Max $40.00"
            }
        }
    },
    HZ: {
        name: getSupplierName('HZ'),
        data: {
            [tableKeys.ADDITIONAL_DRIVER]: {
                pricing: "$3.30 per driver",
                details: "Capped at 5 days $16.50"
            },
            [tableKeys.UNDERAGE_SURCHARGE]: {
                pricing: "$16.50 - $27.50 per day",
                details: "Capped at 7 days per 30 days rental period\nCapped at 7 days per 30 days"
            },
            [tableKeys.PHL]: {},
            [tableKeys.GPS]: {
                pricing: "$20.90 per day",
                details: "Capped at 10 days per 30 days"
            },
            [tableKeys.RF_SEAT]: {
                pricing: "$22.00 per day",
                details: "Max $88.00"
            },
            [tableKeys.FF_SEAT]: {
                pricing: "$22.00 per day",
                details: "Max $88.00"
            },
            [tableKeys.BOOSTER_SEAT]: {
                pricing: "$22.00 per day",
                details: "Max $88.00"
            }
        }
    },
    NB: {
        name: getSupplierName('NB'),
        data: {
            [tableKeys.ADDITIONAL_DRIVER]: {
                pricing: "$5.00 per driver per day",
                details: "Max $25.00 each driver"
            },
            [tableKeys.UNDERAGE_SURCHARGE]: {
            },
            [tableKeys.PHL]: {
                details: "Accepted",
            },
            [tableKeys.GPS]: {
                pricing: "$5.00 per day",
                details: "Max charge $50.00"
            },
            [tableKeys.RF_SEAT]: {
                pricing: "$8.00 per day",
                details: "Max $80.00 each"
            },
            [tableKeys.FF_SEAT]: {
                pricing: "$8.00 per day",
                details: "Max $80.00 each"
            },
            [tableKeys.BOOSTER_SEAT]: {
                pricing: "$8.00 per day",
                details: "Max $80.00 each"
            }
        }
    },
    SX: {
        name: getSupplierName('SX'),
        data: {
            [tableKeys.ADDITIONAL_DRIVER]: {
                pricing: "$5.50 per day",
            },
            [tableKeys.UNDERAGE_SURCHARGE]: {
                pricing: "$25 per day"
            },
            [tableKeys.PHL]: {
                details: "Accepted",
            },
            [tableKeys.GPS]: {},
            [tableKeys.RF_SEAT]: {
                pricing: "$12.65 per day",
            },
            [tableKeys.FF_SEAT]: {
                pricing: "$12.65 per day",
            },
            [tableKeys.BOOSTER_SEAT]: {
                pricing: "$12.65 per day",
            }
        }
    },
    TH: {
        name: getSupplierName('TH'),
        data: {
            [tableKeys.ADDITIONAL_DRIVER]: {
                pricing: "$5.50 per driver per day",
                details: "Capped at $27.50 per driver"
            },
            [tableKeys.UNDERAGE_SURCHARGE]: {
                pricing: "$15.00 per day"
            },
            [tableKeys.PHL]: {
                details: "Accepted",
            },
            [tableKeys.GPS]: {
                pricing: "$20.90 per day",
            },
            [tableKeys.RF_SEAT]: {
                pricing: "$24.20 per day",
            },
            [tableKeys.FF_SEAT]: {
                pricing: "$24.20 per day",
            },
            [tableKeys.BOOSTER_SEAT]: {
                pricing: "$24.00 per day",
            }
        }
    }
}

export default suppliers;
